const tab = {
  namespaced: true,
  state: {
    item: "all",
  },
  mutations: {
    setTab(state, payload) {
      state.item = payload;
    },
  },
  actions: {},
  getters: {},
};

export default tab;
